import { useStoreSelector } from 'hooks/store.ts'
import { selectSpecificAccessRight } from 'store/access-rights/slice.ts'
import { AccessRightKeys } from 'store/access-rights/constants.ts'
import { AccessRights } from 'store/access-rights/types.ts'

/**
 * Custom hook to get a specific access right from the Redux store based on the provided key and type it correctly.
 */
const useGetAccessRight = <K extends AccessRightKeys>(accessRightKey: K): AccessRights[K] => {
  // Redux store
  const accessRight = useStoreSelector((store) => selectSpecificAccessRight(store, accessRightKey))

  return accessRight as AccessRights[K]
}

export default useGetAccessRight
